module.exports = __webpack_public_path__ + "img/zuijia_20.d8f57c04.png";